import React from "react";
import portofolio from '../asset/portofolio.jpg';
import port2 from '../asset/port2.png';
import port3 from '../asset/port3.png';

const Projects = () => {
    return (
        <section id="projects" className="py-20 bg-white">
            <div className="container mx-auto text-center">
                <h2 className="text-4xl font-bold mb-8" style={{ fontFamily: 'Young, serif' }}>My Projects</h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="bg-lime-300 p-4 rounded-3xl">
                        <img src={portofolio} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-3xl"/>
                        <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Young, serif' }}>UI Web Music</h3>
                        <p className="text-center mt-6" style={{ fontFamily: 'Roboto, sans-serif' }}>Contains music playlist from national and international singers</p>
                    </div>

                    <div className="bg-lime-300 p-4 rounded-3xl">
                        <img src={port2} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-3xl"/>
                        <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Young, serif' }}>Weather App</h3>
                        <p className="text-center mt-6" style={{ fontFamily: 'Roboto, sans-serif' }}>Weather App is an aplication that is used to detecd the weather at our location in variouse place</p>
                    </div>

                    <div className="bg-lime-300 p-4 rounded-3xl">
                        <img src={port3} alt="Samuel Wattimena" className="w-full h-48 object-cover mb-4 rounded-3xl"/>
                        <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Young, serif' }}>Gif Generator</h3>
                        <p className="text-center mt-4" style={{ fontFamily: 'Roboto, sans-serif' }}>Gif Generator with Framework React JS SCTEE-G</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Projects